import { render, staticRenderFns } from "./RiskReturnsMethodology.vue?vue&type=template&id=4e7f6495&"
import script from "./RiskReturnsMethodology.vue?vue&type=script&lang=js&"
export * from "./RiskReturnsMethodology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports